import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ForgotPasswordService } from "@foh/publicpages/forgot-password/forgot-password-page.service";

@Component({
    selector: 'app-reset-password-page',
    templateUrl: './reset-password-page.component.html',
    styleUrls: ['./reset-password-page.component.scss']
})

export class ResetPasswordPageComponent {
    @ViewChild('f') forogtPasswordForm: NgForm;

    message: any;
    token: any;
    routeObs$: any;
    constructor(private router: Router,
        private activeRoute: ActivatedRoute,
        private forgotPasswordService: ForgotPasswordService
    ) { }

    ngOnInit() {
        this.message = "Loading, Please wait...";
        this.routeObs$ = this.activeRoute.params.subscribe(
            (params) => {
                this.token = params["token"];
                this.forgotPasswordService.resetPassword({ token: this.token }).subscribe((response: any) => {
                    if (response) {
                        this.message = "Password is reset, Please check your email for your login steps";
                    } else {
                        this.message = "Password Reset Token is invalidated, Please navigate to the Recover password page to repeat the steps";
                    }
                });
            }
        );
    }

    onLogin() {
        this.router.navigate(['login']);
    }
    onForgotPassword() {
        this.router.navigate(['forgot-password']);
    }
}